
// import './App.css';
// import { HashRouter, Routes, Route } from "react-router-dom";

// import Navbar from "./components/Navbar";
// import MapLocation from "./components/MapLocation";

// // Page Components
// import Home from "./pages/Home.jsx";           // ← Recommended: move Home content here
// import ReportSection from "./components/Reportsection";
// import MainFooter from './components/MainFooter.jsx';
// import AboutUs from './components/AboutUs.jsx';
// import LeaderShip from './AboutUs/LeaderShip.jsx';
// import TeamMember from './AboutUs/TeamMember.jsx';
// import PastPresedent from './AboutUs/PastPresident.jsx';


// function App() {
//   return (
//     <div className="App">
//       <HashRouter>
//         {/* Navbar visible on ALL pages */}
//         <Navbar />

//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/knowledge-report" element={<ReportSection />} />
//           <Route path="/about-us" element={<AboutUs />} />
//           <Route path="/about/leadership" element={<LeaderShip />} />
//           <Route path="/about/our-team" element={<TeamMember />} />
//           <Route path="/about/past-president" element={<PastPresedent />} />
//         </Routes>

//         {/* MapLocation visible on ALL pages */}
//         <MainFooter />
//       </HashRouter>
//     </div>
//   );
// }

// export default App;




// new new code 




import './App.css';
import { HashRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";   // ← Import here
import MapLocation from "./components/MapLocation";

// Page Components
import Home from "./pages/Home.jsx";
import ReportSection from "./components/Reportsection";
import MainFooter from './components/MainFooter.jsx';
import AboutUs from './components/AboutUs.jsx';
import LeaderShip from './AboutUs/LeaderShip.jsx';
import TeamMember from './AboutUs/TeamMember.jsx';
import PastPresedent from './AboutUs/PastPresident.jsx';
import Membership from './components/MemberShip.jsx';
import PressRelease from './News/PressRelease.jsx';
import PressCoverage from './News/PressCoverage.jsx';
import MemberShipOverview from './components/MemberShipOverview.jsx';
import GlobalResearch from './GlobalResearch/GlobalResearch.jsx';
import ResearchRepositoryPage from './GlobalResearch/ResearchRepositoryPage.jsx';
import KnowledgeSection from './KnowledgeCenter/KnowledgeSection.jsx';
import HomeKnowledge from './KnowledgeCenter/HomeKnowledge.jsx';

import AboutKnowledge from './KnowledgeCenter/AboutKnowledge.jsx';
import AssochamReports from './KnowledgeCenter/AssochamReport.jsx';
import AssochamVoice from './KnowledgeCenter/AssochamVoice.jsx';
import AssochamBulletins from './KnowledgeCenter/AssochamBulletins.jsx';
import KnowledgeDetail from './KnowledgeCenter/AboutKnowledge.jsx';
import HeroBgSection from './HeroBgSection.jsx';
import ImageLibrary from './News/ImageLibrary.jsx';
import KnowledgeItemDetail from './KnowledgeCenter/KnowledgeItemDetail.jsx';
import MemberShipPlan from './components/MemberShipPlan.jsx';

function App() {
  return (
    <div className="App">
      <HashRouter>
        {/* Navbar visible on ALL pages */}
        <Navbar />

        {/* Scroll to top on every route change */}
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/knowledge-report" element={<ReportSection />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/about/leadership" element={<LeaderShip />} />
          <Route path="/about/our-team" element={<TeamMember />} />
          <Route path="/about/past-president" element={<PastPresedent />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/overview" element={<MemberShipOverview />} />
          <Route path="/membership-types" element={<MemberShipPlan />} />
          <Route path="/newsroom/press-release" element={<PressRelease />} />
            <Route path="/newsroom/press-coverage" element={<PressCoverage />} />
            <Route path="/global-research" element={<GlobalResearch />} />

             <Route path="/global-research/economic-growth" element={<ResearchRepositoryPage categoryKey="egd" />} />
          <Route path="/global-research/eodb" element={<ResearchRepositoryPage categoryKey="eodb" />} />
          <Route path="/global-research/tips" element={<ResearchRepositoryPage categoryKey="tips" />} />
          <Route path="/global-research/publications" element={<ResearchRepositoryPage categoryKey="publications" />} />
           {/* Knowledge Center */}

          <Route path="/overview-knowledge-center" element={<HomeKnowledge />} />
          <Route path="/knowledge/reports" element={<AssochamReports />} />
<Route path="/knowledge/reports/:id" element={<KnowledgeItemDetail dataKey="reports" />} />

<Route path="/knowledge/assocham-voice" element={<AssochamVoice />} />
<Route path="/knowledge/assocham-voice/:id" element={<KnowledgeItemDetail dataKey="voices" />} />

<Route path="/knowledge/bulletins" element={<AssochamBulletins />} />
<Route path="/knowledge/bulletins/:id" element={<KnowledgeItemDetail dataKey="bulletins" />} />
       

          <Route path="/knowledge/bulletins" element={<AssochamBulletins />} />
          <Route path="/newsroom/image-library" element={<ImageLibrary />} />
          
          

          
        </Routes>

        {/* Footer visible on ALL pages */}
        <MainFooter />
      </HashRouter>
    </div>
  );
}

export default App;